import React from 'react';
import { Container } from '@mui/material';
import MeetingForm from '../components/Meeting/MeetingForm';

const CreateMeeting = () => {
    return (
        <Container maxWidth="md" sx={{ py: 4 }}>
            <MeetingForm />
        </Container>
    );
};

export default CreateMeeting;